export const englishMessages = {
	en: 'English',
	he: 'עברית',
	pt: 'Português',
	es: 'Espanhol',
	it: 'Italiano',
	PROFILE_IMAGE: 'Profile Image',
	NAME: 'Name',
	PRICE: 'Price',
	SEARCH: 'Search',
	IS_READ: 'IsRead',
	DATE: 'Date',
	DASHBOARD_WELCOME: 'Dashboard Welcome',
	DASHBOARD: 'Dashboard',
	MONTHLY_REVENUE: 'Monthly Revenue',
	NEW_ORDERS: 'New Orders',
	MONTH_HISTORY: 'Users joined last 30 days',
	VEHICLE_COLORS: 'Vehicle Colors',
	LEADS: 'Leads',
	FROM_DATE: 'From Date',
	TO_DATE: 'To Date',
	GENDER: 'Gender',
	FULL_NAME: 'Full Name',
	HAS_CREDIT: 'Has Credit?',
	BUDGET: 'Budget',
	TOTAL: 'Total',
	VEHICLE_COLOR: 'Vehicle Color',
	FROM_CREATED_AT: 'From Created At',
	TO_CREATED_AT: 'Til Created At',
	COACH_FOLLOWUP: 'Coach Followup',
	COACH_FOLLOWUPS: 'Coach Followups',
	ORGANIZATION_NOTIFICATION: 'Organizational Notification',
	ORGANIZATION_NOTIFICATIONS: 'Organizational Notifications',

	DAY_IN_MONTH: 'Day in month',
	NUMBER_OF_DAYS_SINCE_CLIENT_START: 'Number of days since client start',

	BODY: 'Content',

	TRAINEE: 'Trainee',
	TRAINEES: 'Trainees',

	COACH: 'Coach',
	COACHES: 'Coaches',

	RECIPE_CATEGORY: 'Recipe Category',
	RECIPE_CATEGORIES: 'Recipe Categories',

	RECIPE: 'Recipe',
	RECIPES: 'Recipes',

	TAG: 'Tag',
	TAGS: 'Tags',

	COACH_GUIDE_CATEGORY: 'Coach Guide Category',
	COACH_GUIDE_CATEGORIES: 'Coach Guides Categories',

	COACH_GUIDE: 'Coach Guide',
	COACH_GUIDES: 'Coach Guides',

	PRODUCT: 'Product',
	PRODUCTS: 'Products',

	PRODUCT_CATEGORY: 'Product Category',
	PRODUCT_CATEGORIES: 'Product Categories',

	MARATHON: 'Marathon',
	MARATHONS: 'Marathons',

	DYNAMIC_CARD: 'Dynamic Card',
	DYNAMIC_CARDS: 'Dynamic Cards',

	BILLBOARD: 'Billboard',
	BILLBOARDS: 'Billboards',

	TRAINING: 'Training',
	TRAININGS: 'Trainings',

	LIVE_TRAINING: 'Live Training',
	LIVE_TRAININGS: 'Live Trainings',

	LIVE_TRAININGS_MESSAGE: 'Live Training Message',
	LIVE_TRAININGS_MESSAGES: 'Live Trainings Messages',

	START_HOUR: 'Start Hour',
	END_HOUR: 'End Hour',

	TRAINING_CATEGORY: 'Training Category',
	TRAINING_CATEGORIES: 'Training Categories',

	SUCCESS_STORY_CATEGORY: 'Success Story Category',
	SUCCESS_STORY_CATEGORIES: 'Success Story Categories',
	SUCCESS_STORY: 'Success Story',
	SUCCESS_STORIES: 'Success Stories',
	IMAGE: 'Image',
	DESCRIPTION: 'Description',
	ABOUT_ORGANIZATION: 'About Your Organization',
	Male: 'Male',
	Female: 'Female',
	FEATURED_IMAGE: 'Featured Image',
	TITLE: 'Title',
	CATEGORY: 'Category',
	CREATED_BY: 'Created by',
	ORGANIZATION: 'Organization',
	GALLERY: 'Gallery',
	DYNAMIC_CATEGORY_DEFAULT_IMAGE: 'Dynamic category default image',
	LOGO_IMAGE: 'Logo',
	MARATHONS_FLAG: 'Are marathons available?',
	SUCCESS_STORY_FLAG: 'Coaches can upload success story from the app?',
	COACH_FOLDER_FLAG: 'Coaches folder is publicly for all trainees?',
	COACH_REMINDER_EVERY: 'Remind coaches every...',
	COACH_REMINDER_EVERY_TYPE: 'Period',
	TRAINEE_REMINDER_EVERY: 'Remind trainees every...',
	TRAINEE_REMINDER_EVERY_TYPE: 'Period',
	Admin: 'Admin',
	Regular: 'Regular',
	EQUALS: 'Equals',
	CONTAINS: 'Contains',
	BETWEEN: 'Between',
	Pending: 'Pending',
	Approved: 'Approved',
	SMS: 'Sms',
	Email: 'Email',
	All: 'All',
	Toning: 'Toning',
	Mass: 'Mass',
	Coach: 'Coach',
	Trainee: 'Trainee',
	Organization: 'Organization',
	Vegetarian: 'Vegetarian',
	Hours: 'Hours',
	Days: 'Days',
	DAY: 'Day',
	Weeks: 'Weeks',
	Months: 'Months',
	FEATURED_IMAGE_URL: 'Featured Image Url',
	AGENDA: 'Agenda',
	DURATION: 'Duration',
	PHONE: 'Phone',
	MENU_PDF_URL: 'Menu Pdf Url',
	BIRTH_DATE: 'Birth Date',
	EMAIL: 'Email',
	HEIGHT: 'Height',
	WEIGHT: 'Weight',
	TRAINING_TYPE: 'Training Type',
	APPROVED_BY_COACH: 'Approved by Coach',
	ADDRESS: 'Address',
	SHOULD_RECEIVE_MOTIVATION_NOTIFICATIONS: 'Should Receive Motivation Notifications',
	SHOULD_RECEIVE_WEIGHTING_REMINDER: 'Should Receive Weighting Reminder',
	SHOULD_RECEIVE_SENDING_IMAGE_REMINDER: 'Should Receive Sending Image Reminder',
	SHOULD_COACH_RECEIVE_PERSONAL_MESSAGES_REMINDER: 'Should Coach Receive Personal Messages Reminder',
	SHOULD_COACH_RECEIVE_TRAINEES_PROGRESS_REMINDER: 'Should Coach Receive Trainees Progress Reminder',
	SHOULD_COACH_RECEIVE_BIRTHDAY_NOTIFICATIONS: 'Should Coach Receive Birthday Notifications',
	SHOULD_COACH_RECEIVE_NON_UPLOADERS_REMINDER: 'Should Coach Receive Non Uploaders Reminder',
	NOTE: 'Note',
	VIDEO: 'Video',
	VIDEO_LINK: 'Video Link',
	YOUTUBE_LINK: 'Youtube Link',
	EXTERNAL_LINK: 'External Link',
	IFRAME_URL: 'Iframe Url',
	ORDER: 'Order',
	CARBS: 'Carbs',
	PROTEINS: 'Proteins',
	LINK: 'Link',
	NUMBER_OF_PARTICIPANTS: 'Number of Participants',
	TOTAL_ACTIVE_MARATHONS: 'Total Marathons',
	TOTAL_ACTIVE_COACHES: 'Total Coaches',
	TOTAL_ACTIVE_TRAINEES: 'Total Trainees',
	TOTAL_CLIENTS: 'Total Users',
	ORGANIZATION_SETTINGS: 'Organization Settings',
	LANGUAGE: 'Language',
	HEBREW: 'Hebrew',
	ENGLISH: 'English',
	ITALIAN: 'Italian',
	TOTAL_COACHES_CREATED: 'Trainees became Coaches',
	MAX_NO_WEIGHT_DAYS: 'Max No Weight Days',
	COACH_BIRTHDAY_MESSAGE: 'Coach Birthday Message',
	COACH_NEED_TO_WEIGHT_MESSAGE: 'Coach Need To Weight Message',
	COACH_FOLLOW_UP_MESSAGE: 'Coach Follow Up Message',
	TRAINEE_BIRTHDAY_MESSAGE: 'Trainee Birthday Message',
	TRAINEE_NEED_TO_WEIGHT_MESSAGE: 'Trainee Need To Weight Message',
	MARATHON_WEIGHTING_REMINDER_MESSAGE: 'Trainee Need To Weight In Marathon Message',
	COACHES_MARATHON_WEIGHTING_REMINDER_MESSAGE: 'Coaches Need to collect weightings in marathon',
	ORGANIZATIONAL_FOLLOW_UPS: 'Organizational Follow Ups',
	TRAINING_MENU: 'Training Menu',
	TRAINING_MENUS: 'Training Menus',
	ORGANIZATIONS: 'Organizations',
	MENU_FILE: 'Menu File',
	TYPE: 'Training Type',
	FROM_BMR: 'From BMR',
	TO_BMR: 'To BMR',
	SEND: 'SEND',
	ALL: 'All',
	SEND_NOTIFICATIONS_TO_CLIENT: 'Send Notifications To Client',
	SUCCESSFULLY_SENT_NOTIFICATION_TO_ALL: 'Successfully sent notification',
	NOTIFICATIONS: 'Notifications',
	CONTENT: 'Content',
	GROUP_LINK: 'Group Link',
	SPANISH: 'Spanish',
	FILE: 'File',
	PORTUGEUSE: 'Portuguese',
	SAVED_SUCCESSFULLY: 'Saved successfully',
	SENT_SUCCESSFULLY: 'Send successfully',
	VERIFICATION: 'Verification code',
	VERIFICATION_CODE: 'Verification code',
	VERIFICATIONS: 'Verification codes',
	IMAGE_OR_VIDEO: 'Image or Video',
	RECIPIENT: 'Who should receive it?',
	COACH_NEW_TRAINEE_ENLISTED_NOTIFICATION_TITLE: 'Coach new trainee enlisted notification title',
	COACH_NEW_TRAINEE_ENLISTED_NOTIFICATION_DESCRIPTION: 'Coach new trainee enlisted notification description',
	TRAINEE_APPROVED_NOTIFICATION_TITLE: 'Trainee approved notification title',
	TRAINEE_APPROVED_NOTIFICATION_DESCRIPTION: 'Trainee approved notification description',
	COACH_NEW_MARATHON_ENLISTING_NOTIFICATION_TITLE: 'Coach new Marathon enlisting notification title',
	COACH_NEW_MARATHON_ENLISTING_NOTIFICATION_DESCRIPTION: 'Coach new Marathon enlisting notification description',
	TRAINEE_APPROVED_FOR_MARATHON_NOTIFICATION_TITLE: 'Trainee approved for marathon notification title',
	TRAINEE_APPROVED_FOR_MARATHON_NOTIFICATION_DESCRIPTION: 'Trainee approved for marathon notification description',
	COACH_APPROVED_MARATHON_RESULTS_NOTIFICATION_TITLE: 'Coach approved marathon results title',
	COACH_APPROVED_MARATHON_RESULTS_NOTIFICATION_DESCRIPTION: 'Coach approved marathon results description',
	NEW_SUCCESS_STORY_TITLE: 'New success story title',
	NEW_SUCCESS_STORY_DESCRIPTION: 'New success story description',
	COACH_FOLDER_NAME: 'Coach Folder Name',

	DETAILS: 'Details',
	WEIGHTINGS: 'Weightings',
	WEIGHTING: 'Weighting',
	MARATHON_DAY_NUMBER: 'Marathon day no.',
	CREATED_AT: 'Created at...',
	SUPPORTED_LANGUAGES: 'Supported languages',
	DEFAULT_LANGUAGE: 'Default language',
	general: {
		error: 'General Error'
	},
	message: {
		error: 'General Error'
	},
	error: {
		general: 'General Error',
		request: {
			invalid_req_params: 'Invalid request parameters'
		},
		files: {
			empty: 'Empty file / No file sent',
			unsupported_ext: 'Unsupported extension'
		},
		auth: {
			wrong_credentials: 'Wrong credentials',
			not_admin: 'Not an Admin',
			not_client: 'Not a client',
			failed_authenticating_jwt: 'Failed authenticating',
			not_registered: 'Not registered',
			invalid_token: 'Invalid token '
		}
	},
	resources: {
		'verification': { name: 'Verification code' },
		'verifications': { name: 'Verification codes' },

		'training-menu': { name: 'Training Menu' },
		'training-menus': { name: 'Training Menus' },

		'organization': { name: 'Organization' },
		'organizations': { name: 'Organizations' },

		'trainee': { name: 'Trainee' },
		'trainees': { name: 'Trainees' },

		'coach': { name: 'Coach' },
		'coaches': { name: 'Coaches' },

		'recipe-category': { name: 'Recipe Category' },
		'recipe-categories': { name: 'Recipe Categories' },

		'recipe': { name: 'Recipe' },
		'recipes': { name: 'Recipes' },

		'coach-guide-category': { name: 'Coach Guide Category' },
		'coach-guide-categories': { name: 'Coach Guide Categories' },

		'coach-guide': { name: 'Coach Guide' },
		'coach-guides': { name: 'Coach Guides' },

		'product': { name: 'Product' },
		'products': { name: 'Products' },

		'product-category': { name: 'Product Category' },
		'product-categories': { name: 'Product Categories' },

		'marathon': { name: 'Marathon' },
		'marathons': { name: 'Marathons' },

		'dynamic-card': { name: 'Dynamic-card' },
		'dynamic-cards': { name: 'Dynamic-cards' },

		'billboard': { name: 'Billboard' },
		'billboards': { name: 'Billboards' },

		'training': { name: 'Training' },
		'trainings': { name: 'Trainings' },

		'training-category': { name: 'Training Category' },
		'training-categories': { name: 'Training Categories' },

		'success-story-category': { name: 'Success-story Category' },
		'success-story-categories': { name: 'Success-story Categories' },
		'success-story': { name: 'Success Story' },
		'success-stories': { name: 'Success Stories' },
		'vehicle-color': { name: 'Vehicle Color' },
		'lead': { name: 'Lead' }
	},
	ra: {
		action: {
			clear_input_value: 'Clear',
			delete: 'Delete',
			unselect: 'Unselect',
			sort: 'Sort',
			show: 'Show',
			undo: 'Undo',
			confirm: 'Confirm',
			bulk_actions: '%{smart_count} selected items',
			list: 'List',
			export: 'Export',
			save: 'Save',
			create: 'Create',
			edit: 'Edit',
			cancel: 'Cancel',
			refresh: 'Refresh',
			add_filter: 'Add filter',
			remove_filter: 'Remove filter',
			back: 'Back'
		},
		boolean: {
			true: 'Yes',
			false: 'No'
		},
		page: {
			list: '%{name} List',
			edit: '%{name} #%{id}',
			show: '%{name} #%{id}',
			empty: 'Empty results',
			invite: 'We hope there\'ll be some data soon',
			create: 'Create %{name}',
			delete: 'Delete %{name} #%{id}',
			dashboard: 'Dashboard',
			not_found: 'Not found',
			error: 'Error'
		},
		input: {
			references: {
				single_missing: 'Missing'
			},
			file: {
				upload_several:
					'Drag and drop files or Click to upload.',
				upload_single: 'Drag and drop a file or Click to upload.'
			},
			image: {
				upload_several:
					'Drag and drop images or Click to upload.',
				upload_single:
					'Drag and drop an image or Click to upload.'
			}
		},
		message: {
			error: 'Oops... an error occured',
			invalid_form: 'Invalid form',
			yes: 'Yes',
			no: 'No',
			are_you_sure: 'Are you sure?',
			about: 'About',
			not_found:
				'You\'ve inserted a wrong url or navigated incorrectly',
			delete_title: 'Delete',
			delete_content: 'Are you sure you\'d like to delete?',
			bulk_delete_title: 'Note!',
			bulk_delete_content: 'Are you sure you\'d like to delete ALL the entities?'
		},
		navigation: {
			no_results: 'Couldn\'t find results',
			page_rows_per_page: 'Row per page',
			skip_nav: 'Skip',
			page_out_of_boundaries: 'Page out of boundaries',
			page_out_from_end: 'Page out from end',
			page_out_from_begin: 'Page out from start',
			page_range_info: '%{offsetBegin}-%{offsetEnd} out of %{total}',
			next: 'Next',
			prev: 'Prev.'
		},
		auth: {
			username: 'Username',
			password: 'Password',
			sign_in: 'Sign in',
			sign_in_error: 'Sign in error',
			logout: 'Logout',
			auth_check_error: 'Authentication failed'
		},
		notification: {
			data_provider_error: 'Connectivity error (Data provider)',
			updated: 'Entity updated successfully',
			created: 'Entity created successfully',
			deleted: 'Entity deleted successfully',
			item_doesnt_exist: 'Item does not exist',
			http_error: 'Connectivity error (Http)'
		},
		validation: {
			required: 'Required field',
			minLength: 'Should contain at least %{min} characters',
			maxLength: 'Should contain up to %{max} characters',
			minValue: 'Value should be at least %{min}',
			maxValue: 'Value should be up to %{max}',
			number: 'Value should be a number',
			email: 'Invalid email'
		}
	}
};
